import GraphicStandSelect from './graphic-stand-select-form-item';

export default GraphicStandSelect;